import { useTranslation } from "react-i18next";
import { VaporPageStickable } from "@vapor/react-contrib-tax-compliance";
import Typography from "@vapor/react-extended/ExtendedTypography";
import { Stack, useTheme } from "@vapor/react-material";

/**
 * Shown when the tenant workspace cannot be determined once loading is over:
 * either the workspace list failed, or the current organization has no
 * workspace of its own. Both leave the app with no tenant to operate on, and
 * from the user's side they are the same dead end.
 */
export const WorkspaceNotAvailable = () => {
    const { t } = useTranslation();
    const theme = useTheme();

    return (
        <VaporPageStickable>
            <Stack justifyContent="center" alignItems="center">
                <Typography
                    variant="h4"
                    color={theme.palette.primary.textTitleColor}
                >
                    {t("components.workspace_not_available.unavailable")}
                </Typography>
            </Stack>
        </VaporPageStickable>
    );
};
